import { Moment } from "moment";
import { Component, Inject, Injector, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GenericComponent } from "@shared/components/generic.component";
import { BudgetService } from "@core/services/budget.service";
import { BudgetDetails } from "@shared/models/service-request-details-dto";
import { PeriodDTO } from "@shared/models/period-dto";
import { Validators } from "@angular/forms";
import { ServiceRequestService } from "@core/services/service-request.service";
import { DateAdapter } from "@angular/material/core";
import { LabelService, defaultMileageUnit } from "@core/services/label.service";

interface PropsType {
  budgetDetails?: BudgetDetails;
  currentKm: number;
  serviceType: string;
}

@Component({
  templateUrl: "./modal-confirm-vehicle-arrival.component.html",
  styleUrls: ["./modal-confirm-vehicle-arrival.component.scss"],
  standalone: false
})
export class ModalConfirmVehicleArrivalComponent
  extends GenericComponent
  implements OnInit
{
  form = this.fb.group({
    date: ["", Validators.required],
    arrivalTime: ["", Validators.required],
    arrivalDate: ["", Validators.required],
    period: ["", Validators.required],
    carWorkshopKm: ["", Validators.required],
    vehicleArrivalConfirmationDateByUser: [""]
  });

  periods: PeriodDTO[] = [];
  canShowWarning = false;
  currentKm: number;
  serviceType: string;

  mileageUnit = defaultMileageUnit;

  constructor(
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: PropsType,
    private budgetService: BudgetService,
    private serviceRequestService: ServiceRequestService,
    private matDialogRef: MatDialogRef<ModalConfirmVehicleArrivalComponent>,
    private dateAdapter: DateAdapter<any>,
    private labelService: LabelService
  ) {
    super(injector);
    this.currentKm = data.currentKm;
    this.serviceType = data.serviceType;
  }

  ngOnInit(): void {
    this.mileageUnit = this.labelService.getMileageUnit();
    this.listAllPeriod();
    if (this.data?.budgetDetails) {
      this.canShowWarningBudget(this.data.budgetDetails);
    }
    this.dateAdapter.setLocale(this.translateService.currentLang.toLowerCase());
  }

  private listAllPeriod(): void {
    this.serviceRequestService.listAllTypePeriod().subscribe(
      (periods) => {
        this.periods = periods;
      },
      (error) => {
        this.showErrorMessage(error, "Error to list periods");
      }
    );
  }

  private canShowWarningBudget(budget: BudgetDetails): void {
    this.budgetService.hasVerificationItems(budget.id).subscribe(
      (data) => {
        this.canShowWarning = data;
      },
      (error) => {
        this.showErrorMessage(error, "Error to find Budget");
      }
    );
  }

  private formatDateTime(date: Date, time?: string): string {
    const pad = (n: number) => (n < 10 ? "0" + n : n);

    if (time) {
      const [hours, minutes] = time.split(":").map(Number);
      date.setHours(hours, minutes, 0, 0);
    }

    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      "T" +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes()) +
      ":" +
      pad(date.getSeconds())
    );
  }

  closeDialog(isSubmitted: boolean): void {
    if (isSubmitted && this.validaDate()) {
      const arrivalDate = new Date(this.form.get("arrivalDate")?.value);
      const arrivalTime = this.form.get("arrivalTime")?.value;

      const formatted = this.formatDateTime(arrivalDate, arrivalTime);

      this.form
        .get("vehicleArrivalConfirmationDateByUser")
        ?.setValue(formatted);

      const payload = {
        ...this.form.getRawValue(),
        arrivalDate: this.formatDateTime(
          new Date(this.form.get("arrivalDate")?.value)
        ),
        date: this.formatDateTime(new Date(this.form.get("date")?.value)),
        vehicleArrivalConfirmationDateByUser: formatted
      };

      return this.matDialogRef.close(payload);
    }

    this.matDialogRef.close(null);
  }

  getOnlyNumbersMask() {
    return this.maskService.getOnlyNumbersMask();
  }

  validaDate(): boolean {
    const inputDate = this.form.get("arrivalDate")?.value;
    const inputTime = this.form.get("arrivalTime")?.value;
    const today = new Date();

    if (!inputDate || !inputTime) return false;

    const dateObj = new Date(inputDate);
    const [hours, minutes] = inputTime.split(":").map(Number);

    dateObj.setHours(hours, minutes, 0, 0);

    if (dateObj > today) {
      this.form.get("arrivalDate")?.setErrors({
        isGreaterThanCurrentDate: true
      });
      return false;
    } else {
      this.form.get("arrivalDate")?.setErrors(null);
      return true;
    }
  }

  checkMinValue(): void {
    const value = this.form.get("carWorkshopKm").value;
    if (value != null && (value == 0 || value < this.currentKm)) {
      this.form.get("carWorkshopKm").setErrors({
        isGreatherThanCurrentKm: true
      });
    }
  }

  private combineDateAndTime(): string {
    const date = this.form.get("arrivalDate")?.value;
    const time = this.form.get("arrivalTime")?.value;

    return `${date}T${time}:00`;
  }
}
